import { render, staticRenderFns } from "./MachineInsightsConfiguration.vue?vue&type=template&id=bf61b8c0&scoped=true"
import script from "./MachineInsightsConfiguration.vue?vue&type=script&lang=js"
export * from "./MachineInsightsConfiguration.vue?vue&type=script&lang=js"
import style0 from "./MachineInsightsConfiguration.vue?vue&type=style&index=0&id=bf61b8c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf61b8c0",
  null
  
)

export default component.exports